import { RichText } from 'prismic-reactjs';

/**
 * If data is not empty, return text value. Otherwise, return null.
 * @param {*} data
 */
export const asTextOrNull = data => {
  return data ? RichText.asText(data) : null;
};
